module.exports = __webpack_public_path__ + "img/sms.f9ed0525.png";